<template>
  <v-data-table
    :headers="headers"
    :items="items"
    class="elevation-1"
    :hide-default-footer="true"
    :items-per-page="-1"
    disable-pagination
  >
    <template slot="no-data"> Desculpe, nenhum registro encontrado. </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-btn
          color="#EBE6E6"
          light
          class="mb-2"
          rounded
          v-bind="$attrs"
          @click="dialog = true"
          :disabled="view"
        >
          + NOVO
        </v-btn>
        <validation-observer v-if="dialog" ref="observer" v-slot="{ invalid }">
          <BaseDialog title="NOVO BANCO" :value="dialog" @input="close">
            <v-container>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-autocomplete
                    @change="changeBank"
                    :items="banks"
                    item-value="numerooficial"
                    item-text="nome"
                    outlined
                    v-model="editedItem.num_bank"
                    label="Banco *"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-autocomplete
                    :items="accountTypes"
                    outlined
                    v-model="editedItem.account_type"
                    label="Tipo de Conta *"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-autocomplete
                    :items="payment_method"
                    item-text="text"
                    label="Forma de Pagamento"
                    v-model="editedItem.payment_method"
                    :disabled="isDisable(editedItem.num_bank)"
                    outlined
                    hide-details="auto"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <BaseInputValidation
                    id="agency"
                    name="Agência *"
                    rules="required|max:6"
                    :counter="6"
                    v-model="editedItem.agency"
                  ></BaseInputValidation>
                </v-col>
                <v-col cols="2">
                  <BaseInputValidation
                    id="agency"
                    name="Dígito"
                    rules="max:2"
                    :counter="2"
                    v-model="editedItem.agency_digit"
                  ></BaseInputValidation>
                </v-col>
                <v-col cols="5">
                  <BaseInputValidation
                    id="account"
                    name="Conta Corrente *"
                    rules="required|max:15"
                    :counter="15"
                    v-model="editedItem.account"
                  ></BaseInputValidation>
                </v-col>
                <v-col cols="2">
                  <BaseInputValidation
                    id="phone"
                    name="Dígito"
                    rules="max:2"
                    :counter="2"
                    v-model="editedItem.account_digit"
                  ></BaseInputValidation>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <BaseInputValidation
                    id="note"
                    inputType="textarea"
                    name="Observação *"
                    rules="required|max:500"
                    :counter="500"
                    v-model="editedItem.note"
                  ></BaseInputValidation>

                  <h3>A conta deve ser vinculada ao CNPJ/CPF da empresa.</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3>Comprovante da conta bancária *</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <validation-provider name="arquivo" rules="required">
                    <input
                      style="display: none"
                      ref="file"
                      type="file"
                      accept="application/pdf,image/png,image/jpeg"
                      @change="changeFile"
                    />
                    <v-btn rounded @click="$refs.file.click()">
                      + Escolher Arquivo
                    </v-btn>
                    <span class="text-h6 ml-5">{{ editedItem.filename }}</span>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-container>
            <template v-slot:actions>
              <v-col cols="3">
                <v-btn color="red darken-1" dark @click="close" block rounded>
                  CANCELAR
                </v-btn>
              </v-col>
              <v-col cols="3">
                <v-btn
                  block
                  rounded
                  :disabled="invalid"
                  color="primary darken-1"
                  @click="save"
                >
                  INCLUIR
                </v-btn>
              </v-col>
            </template>
          </BaseDialog>
        </validation-observer>
      </v-toolbar>
    </template>
    <template v-slot:[`item.proof`]="{ item }">
      <v-icon
        v-if="item.arquivo64"
        large
        class="mr-2"
        @click="downloadItem(item)"
      >
        mdi-download
      </v-icon>
    </template>
    <template v-slot:[`item.actions`]="{ item }" v-if="!view">
      <v-row>
        <v-col cols="auto">
          <v-icon medium class="mt-5" @click="editItem(item)">
            mdi-pencil
          </v-icon>
        </v-col>
        <v-col cols="auto">
          <v-switch @change="inactive(item)" v-model="item.active"></v-switch>
        </v-col>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import cloneDeep from "lodash/cloneDeep";

import { ValidationObserver, ValidationProvider } from "vee-validate";

import BaseInputValidation from "../../../../../components/UI/BaseInputValidation";
import BaseDialog from "@/components/UI/BaseDialog";

export default {
  props: {
    view: {
      type: Boolean,
      default: false
    },
    provider: {
      type: Array
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    BaseInputValidation,
    BaseDialog
  },
  data: () => ({
    payment_method: [
      {text: "Crédito em Conta Corrente no mesmo Banco", value: "T"},
      {text: "Título de Cobrança (Boleto)", value: "I"},
      {text: "TED CIP", value: "Y"}
    ],
    dialog: false,
    dialogDelete: false,
    accountTypes: [
      {
        text: "Corrente",
        value: "cc"
      },
      {
        text: "Poupança",
        value: "cp"
      }
    ],
    headers: [
      { text: "", value: "actions", sortable: false },
      { text: "Banco", value: "name_bank" },
      { text: "Tipo de Conta", value: "account_type" },
      { text: "Forma de Pagamento", value: "payment_method" },
      { text: "Agência", value: "agency" },
      { text: "Conta Corrente", value: "account" },
      { text: "Observação", value: "note" },
      { text: "Data de Inativação", value: "date_inactivity", sortable: false },
      { text: "Comprovante", value: "proof", sortable: false }
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      num_bank: "",
      account_type: "",
      name_bank: "",
      payment_method: "",
      agency: "",
      account: "",
      note: "",
      date_inactivity: "",
      proof: "",
      account_digit: "",
      agency_digit: "",
      filename: "",
      arquivo64: []
    },
    defaultItem: {
      num_bank: "",
      account_type: "",
      name_bank: "",
      payment_method: "",
      agency: "",
      account: "",
      note: "",
      date_inactivity: "",
      proof: "",
      account_digit: "",
      agency_digit: "",
      filename: "",
      arquivo64: []
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },

    ...mapGetters({
      banks: "$_bank/banks"
    })
  },

  watch: {
    provider: {
      handler: function(newVal) {
        this.items = cloneDeep(newVal);
      },
      deep: true
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialog(val) {
      this.$emit("hideBar", val);
    },
    'editedItem.num_bank'(newVal) {
        if (newVal == '001') {
          this.payment_method = [{text: "Crédito em Conta Corrente no mesmo Banco", value: "T"},{text: "Título de Cobrança (Boleto)", value: "I"}]
        } else {
          this.payment_method = [{text: "TED CIP", value: "Y"},{text: "Título de Cobrança (Boleto)", value: "I"}]
        }
      
    }
  },

  methods: {
    isDisable(editedItem) {
      return editedItem == "";
    },
    changeBank(event) {
      let bank = this.banks.filter(element => {
        return element.numbanco == event;
      });
      if (bank.length === 1) {
        this.editedItem.name_bank = bank[0].nome;
      }
    },
    changeFormaPagamento(event) {
      let forma_de_pagamento = this.payment_method.filter(element => {
        return element.codtb2flx == event;
      });
      if (forma_de_pagamento.length === 1) {
        this.editedItem.payment_method = forma_de_pagamento.descricao;
      }
    },
    ...mapActions({
      getBanks: "$_bank/index"
    }),

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    editItem(item) {
      this.editedIndex = this.provider.findIndex(
        x =>
          x.num_bank + x.agency + x.account + x.account_type + x.payment_method ===
          item.num_bank + item.agency + item.account + item.account_type + item.payment_method
      );
      this.editedItem = Object.assign({}, item);

      const arquivo64 = this.editedItem.arquivo64;
      if (arquivo64)
        this.editedItem.arquivo64 = this.dataURLtoFile(
          arquivo64,
          this.editedItem.filename
        );

      this.dialog = true;
    },

    async save() {
      const result = this.provider.findIndex(
        x =>
          x.num_bank + x.agency + x.account + x.account_type + x.payment_method ===
            this.editedItem.num_bank +
            this.editedItem.agency +
            this.editedItem.account +
            this.editedItem.account_type +
            this.editedItem.payment_method
      );
      if (result != -1 && this.editedIndex != result) {
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: `Conta já adicionada!`,
          type: "error",
          title: "Error!",
          timeout: 4000
        });
      } else {
        if (this.editedItem.arquivo64.size > 2097152) {
          await this.$store.dispatch(`$_messages/setErrors`, {
            message: `O comprovante da conta deve conter no máximo 2mb.`,
            type: "error",
            title: "Error!",
            timeout: 4000
          });
          return false;
        }
        const reader = new FileReader();
        if (this.editedItem.active == undefined) this.editedItem.active = true;
        reader.readAsDataURL(this.editedItem.arquivo64);
        reader.onload = e => {
          this.editedItem.arquivo64 = e.target.result;
          this.$emit("setFinances", {
            data: this.editedItem,
            index: this.editedIndex
          });

          this.editedItem = Object.assign({}, this.defaultItem);
          this.dialog = false;
        };
      }
    },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    inactive(item) {
      this.editedIndex = this.provider.findIndex(
        x =>
          x.num_bank + x.agency + x.account + x.account_type + x.payment_method ===
          item.num_bank + item.agency + item.account + item.account_type + item.payment_method
      );
      this.$emit("setFinances", {
        data: item,
        index: this.editedIndex
      });
      this.editedIndex = -1;
    },

    changeFile(event) {
      const file = event.target.files[0];
      this.editedItem.arquivo64 = file;
      this.editedItem.filename = file.name;
    },

    downloadItem(item) {
      const linkSource = item.arquivo64;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = item.filename;
      downloadLink.click();
    }
  },

  async created() {
    await Promise.all([
      this.getBanks({limit: -1})
    ]);
    this.items = cloneDeep(this.provider)
  }
};
</script>

<style></style>
